import * as React from 'react';
import EmailField from '../../../../commonComponents/appForm/EmailField';
import { sendForgottenPasswordEmail } from '../../../../core/api';
import { hasValue } from '../../../../lib/lib';
import { EmailModel } from '../../../../models/AccountModels';
import AppForm from '../../common/AppForm';
import PageTitle from '../../common/PageTitle';

const ForgotPasswordForm = ({ onSubmit }: { onSubmit?: () => void }) => {
	const handleSubmit = async (forgotPasswordModel: EmailModel) => {
		await sendForgottenPasswordEmail(forgotPasswordModel);
		onSubmit();
	};

	return (
		<>
			<PageTitle
				title="Forgot password?"
				subtitle="Please enter your email address below to receive a password reset link."
			/>
			<AppForm onSubmit={handleSubmit} primaryButtonText="Reset password" singleColumn>
				<EmailField
					label="Email address"
					required={false}
					validate={(value: string) => hasValue(value) || 'Please enter a valid email address.'}
				/>
			</AppForm>
		</>
	);
};

export default ForgotPasswordForm;
